import { createSlice } from "@reduxjs/toolkit";

const getFromStorage = (key) => {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(key);
};

const saveToStorage = (key, value) => {
  if (typeof window === "undefined") return;
  if (value === null || value === undefined) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
};

const savedToken = getFromStorage("adminAccessToken");
const savedAdmin = getFromStorage("adminData");

const initialState = {
  accessToken: savedToken || null,
  admin: savedAdmin ? JSON.parse(savedAdmin) : null,
  isAuthenticated: Boolean(savedToken),
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, admin } = action.payload || {};
      if (token) {
        state.accessToken = token;
        state.isAuthenticated = true;
        saveToStorage("adminAccessToken", token);
      }
      if (admin) {
        state.admin = admin;
        saveToStorage("adminData", JSON.stringify(admin));
      }
    },
    setAdmin: (state, action) => {
      state.admin = action.payload || null;
      if (action.payload) {
        saveToStorage("adminData", JSON.stringify(action.payload));
      }
    },
    clearCredentials: (state) => {
      state.accessToken = null;
      state.admin = null;
      state.isAuthenticated = false;
      saveToStorage("adminAccessToken", null);
      saveToStorage("adminData", null);
    },
  },
});

export const { setCredentials, setAdmin, clearCredentials } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
